import React, { useState } from 'react';
import { CheckCircle2, Phone } from 'lucide-react';
import { QuoteForm } from '../../components/QuoteForm/QuoteForm';
export function HeroQuotePanel() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
  };
  return <div className="lg:col-span-5 xl:col-span-5 anim-fade-scale" style={{
    animationDelay: '0.2s'
  }} id="quote" data-id="element-234">
      <div className="bg-white rounded-2xl shadow-xl shadow-slate-200/50 border border-slate-100 overflow-hidden relative" data-id="element-235">
        <div className="absolute top-0 left-0 w-full h-1 bg-brand-blue" data-id="element-236"></div>

        <div className="p-5 sm:p-6" data-id="element-237">
          {!isSubmitted ? <>
              <div className="inline-block px-3 py-1 bg-brand-light text-brand-blue text-xs font-bold uppercase tracking-wider rounded-md mb-3" data-id="element-238">
                Free Auto Glass Quote
              </div>
              <h2 className="text-xl lg:text-2xl font-bold text-navy-900 mb-2" data-id="element-239">
                Request a Free Auto Glass Quote
              </h2>
              <p className="text-sm text-slate-600 mb-4" data-id="element-240">
                Submit your details and a Kosin's Glass team member will contact
                you to confirm your vehicle details, glass type, insurance
                information and appointment availability.
              </p>

              <QuoteForm onSubmit={handleSubmit} data-id="element-241" />

              <div className="mt-4 text-center" data-id="element-242">
                <p className="text-xs text-slate-500 mb-1" data-id="element-243">Prefer to call?</p>
                <a href="tel:517-545-7772" className="inline-flex items-center gap-2 text-navy-900 font-bold text-sm hover:text-brand-blue transition-colors" data-id="element-244">
                  <Phone className="w-4 h-4" data-id="element-245" />
                  517-545-7772
                </a>
              </div>

              <div className="mt-4 pt-4 border-t border-slate-100" data-id="element-246">
                <div className="flex items-center gap-1 text-amber-500 text-xs mb-1.5" aria-hidden="true" data-id="element-247">
                  <span data-id="element-248">★</span>
                  <span data-id="element-249">★</span>
                  <span data-id="element-250">★</span>
                  <span data-id="element-251">★</span>
                  <span data-id="element-252">★</span>
                </div>
                <p className="text-xs text-slate-600 italic leading-relaxed" data-id="element-253">
                  "[Paste real customer review here.]"
                </p>
                <p className="text-xs text-slate-500 mt-1" data-id="element-254">
                  — [Customer Name], [City]
                </p>
              </div>
            </> : <div className="py-12 text-center anim-fade-scale" data-id="element-255">
              <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-256">
                <CheckCircle2 className="w-8 h-8" data-id="element-257" />
              </div>
              <h3 className="text-2xl font-bold text-navy-900 mb-3" data-id="element-258">
                Quote Request Received!
              </h3>
              <p className="text-slate-600 mb-8" data-id="element-259">
                Thank you. A Kosin's Glass team member will contact you shortly
                to confirm your vehicle details and provide your free estimate.
              </p>
              <div className="bg-slate-50 p-4 rounded-xl text-sm text-slate-700" data-id="element-260">
                <p className="font-medium mb-2" data-id="element-261">Need immediate assistance?</p>
                <a href="tel:517-545-7772" className="text-brand-blue font-bold hover:underline flex items-center justify-center gap-2" data-id="element-262">
                  <Phone className="w-4 h-4" data-id="element-263" /> Call 517-545-7772
                </a>
              </div>
            </div>}
        </div>
      </div>
    </div>;
}